/**
 * Текст про компанію.
 *
 * Досі він жив прямо в About.js і WhyChooseUs.js — тобто існував лише на
 * головній. Тепер той самий текст потрібен і в короткому вигляді на головній,
 * і повністю на /pro-kompaniyu, тож він переїхав сюди.
 */

export const companyLead = [
  'VMG — це команда професійних юристів із багаторічним досвідом, яка спеціалізується на правовому супроводі медичних закладів та медичної практики: від ідеї до успішного функціонування. Ми допомагаємо лікарям, підприємцям та медичним компаніям впевнено розвиватися, дотримуючись усіх вимог законодавства України.',
  'Медичне право — не одна з наших практик між іншими, а єдина. Це означає, що ми не вивчаємо ліцензійні умови під конкретну справу: ми стежимо за ними постійно й бачимо, як зміна, ухвалена в липні, відгукнеться в документах клініки восени.',
  'Ви фокусуєтесь на здоров’ї пацієнтів — ми дбаємо про юридичну безпеку вашої практики.'
];

export const vision = {
  title: 'Наша візія',
  lead: 'Стати головним правовим архітектором медичного бізнесу в Україні. Ми прагнемо побудувати середовище, де відкриття та розвиток приватної медичної практики є прозорим, швидким та зрозумілим процесом.',
  points: [
    'Бути першою компанією, про яку згадує лікар або підприємець, плануючи відкриття клініки.',
    'Створити середовище юридичної безпеки, у якому бюрократичні ризики передбачені й закриті заздалегідь, а не виявляються в останній момент.',
    'Впроваджувати найвищі стандарти правового сервісу, що сприятимуть розвитку приватної медицини європейського рівня.'
  ]
};

export const mission = {
  title: 'Наша місія',
  lead: 'Знімати юридичний тягар з плечей медиків. Ми переконані, що лікар має лікувати, а менеджер — розвивати бізнес. Наша місія — взяти на себе складні юридичні процеси, забезпечуючи лікарям спокій, а клінікам — безпечне майбутнє.',
  points: [
    'Трансформація складнощів у рішення: робимо складне медичне законодавство зрозумілим та безпечним для бізнесу.',
    'Партнерство, а не просто послуга: ми не просто оформлюємо документи, ми стаємо частиною команди клієнта на кожному етапі.',
    'Професійна підтримка: створення умов, за яких медичний бізнес працює законно, стабільно та прибутково.'
  ]
};

export const values = [
  { icon: 'fas fa-bullseye', title: 'Експертна точність', description: 'У медицині та праві немає місця для помилок. Ми діємо вивірено.' },
  { icon: 'fas fa-eye', title: 'Прозорість', description: 'Клієнт завжди знає, на якому етапі його справа та які реальні шанси на результат.' },
  { icon: 'fas fa-shield-halved', title: 'Відповідальність', description: 'Ми відповідаємо за кожну отриману ліцензію та кожен розроблений документ.' },
  { icon: 'fas fa-puzzle-piece', title: 'Адаптивність', description: 'Швидко реагуємо на зміни в законодавстві, щоб наші клієнти завжди були на крок попереду.' }
];

/**
 * Як влаштована робота — те, чого на сайті не було взагалі. Людина, яка
 * обирає юриста, питає не «які у вас цінності», а «що буде після того, як я
 * напишу». Тут відповідь на це питання.
 */
export const howWeWork = [
  {
    label: 'Розмова',
    text: 'Коротко з’ясовуємо, на якому ви етапі, що вже зроблено й що є на руках. Після цієї розмови ви знаєте, що саме вам потрібно, — навіть якщо далі ми не працюємо разом.'
  },
  {
    label: 'Аудит того, що є',
    text: 'Дивимося наявні документи, приміщення, склад персоналу. Більшість проблем видно саме тут, поки вони ще коштують правок, а не переробок.'
  },
  {
    label: 'Обсяг і умови',
    text: 'Називаємо перелік робіт, строк і вартість до початку. Що входить, а що буде окремим проєктом, фіксуємо словами, а не «за домовленістю».'
  },
  {
    label: 'Робота',
    text: 'Ведемо процедуру й тримаємо вас у курсі на кожному етапі — без потреби питати, як там справи.'
  },
  {
    label: 'Після результату',
    text: 'Пояснюємо, що надалі вимагає вашої уваги: які зміни в закладі потребують подання документів і в які строки. Ліцензія — це стан, а не разова подія.'
  }
];

export const whyUs = [
  'Медичне право — наша основна спеціалізація, а не одна з практик між іншими',
  'Ведемо всі напрямки одразу: реєстрацію, ліцензію, ЕСОЗ і документи — тому бачимо, як вони пов’язані',
  'Партнери компанії закривають суміжні галузі — корпоративне, земельне, трудове, кримінальне право',
  'Працюємо дистанційно по всій Україні: більшість процедур не вимагає вашої присутності',
  'Кажемо, коли послуга вам не потрібна, — це дешевше за втраченого клієнта, який більше не повернеться'
];

/**
 * Команда. Поки порожня — і сторінка це чесно враховує: блок з’являється
 * лише тоді, коли в масиві хтось є. Вигадувати імена й роки практики для
 * юридичної фірми не можна навіть як заглушку.
 *
 * Формат запису:
 *   { name, role, focus, credentials }
 */
export const team = [];
